import { Check } from '@material-ui/icons';
import React from 'react';
import styled, { css } from 'styled-components';

const Container = styled.div`
  text-align: left !important;
  display: flex;
  position: absolute;
  width: 74px;
  height: 30px;
  right: 40px;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  clear: both;
  background: #000;
  border-radius: 28px;
  padding: 5px 10px 6px 10px;
  margin-right: 20px;
  color: #fff;
  ${props =>
    props.selected &&
    css`
      width: 92px;
      background: #ececec;
      color: #676767;
    `};

  :hover {
    border-color: #000;
  }

  > svg {
    vertical-align: middle;
    float: left;
    font-size: 19px;
    margin-right: 5px;
  }

  > span {
    vertical-align: middle;
    display: flex;
    float: left;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -0.2px;
  }

  > a {
    display: flex;
    text-decoration: none !important;
    color: black !important;
  }

  > .add-menu-item {
    vertical-align: middle;
  }
`;

function SelectButton({ selected, onSelect, children, value }) {
  return (
    <React.Fragment>
      {!selected ? (
        <Container
          selected={selected}
          onClick={() => onSelect(value, !selected)}
        >
          <span>{children}</span>
        </Container>
      ) : (
        <Container
          selected={selected}
          onClick={() => onSelect(value, !selected)}
        >
          <Check /> <span>{children}</span>
        </Container>
      )}
    </React.Fragment>
  );
}

export default SelectButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/SelectButton/index.jsx